import React from 'react';
import { Grid, Stack } from '@mui/material';
import { Form } from 'mobx-react-form';
import { observer } from 'mobx-react-lite';
import { wrapForm, FormOptions } from 'components/shared/form';
import { plugins } from 'forms/utils/formPlugins';
import { formOptions } from 'forms/utils/formOptions';
import { OtherIncome } from './OtherIncome';
import { otherIncomeFormFields } from './otherIncomeFormConfig';

const formConfig: FormOptions = {
  fields: otherIncomeFormFields,
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

type OtherIncomeProps = {
  form: Form;
};

const OtherIncomeContainer = observer(({ form }: OtherIncomeProps) => {
  return (
    <Grid container>
      <Stack spacing={2} sx={{ width: '100%', minHeight: 720 }}>
        <OtherIncome form={form} />
      </Stack>
    </Grid>
  );
});

export default wrapForm({
  ...formConfig,
})(OtherIncomeContainer);
